<div style="position: relative; height: 100%; width: 100%;">
    <app-poi-sidebar></app-poi-sidebar>
    <chat-view></chat-view>
</div>